import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HelpIconModule } from '../help-icon/help-icon.module';
import { ActionLabelComponent } from './action-label.component';

@NgModule({
  declarations: [ActionLabelComponent],
  imports: [CommonModule, HelpIconModule],
  exports: [ActionLabelComponent]
})
export class ActionLabelModule {}
